import { XRegExp } from '../../../../xregexp-min';

// Method to get named groups using XRegExp.
export const getNamedGroups = (regExpPattern, value) => {
    const regExp = XRegExp(regExpPattern, 'gi');
    const isMatch = regExp.test(value);

    if (!isMatch) {
        return null;
    }

    return XRegExp.exec(value, regExp);
};
